const titleCase = (string) => {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const topLevelTransforms = (gqlData) => ({
  "hazmat-product": gqlData?.productSummary?.isHazmatProduct,
  "loyalty-product": gqlData?.productSummary?.isLoyaltyProduct,
  tier: gqlData?.tier,
  alsoAvailableIn: gqlData?.alsoAvailableIn,
  whyWeMadeThis: { ...gqlData?.whyWeMadeThisAttributes },
  "has-linked-products": titleCase(
    gqlData?.productSummary?.hasLinkedProducts ?? ""
  ),
  "linked-items": gqlData?.productSummary?.linkedProducts,
  designedFor: gqlData?.colorAttributes?.[0]?.designedFor,
});

export default topLevelTransforms;
